import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { id: String }

  connect() {
    const dialogId = this.idValue
    if (!dialogId) return

    const dialogTrigger = $(`[data-a11y-dialog-show="${dialogId}"]`)
    if (dialogTrigger) dialogTrigger.click()
  }
}
